import React from "react";
import styled from "styled-components";
import { colors } from "./mixins.js";
import { ArrowDown } from "../icons";
import { Loading } from "../icons/Loading";

interface SplitButtonProps {
  text: string;
  onMainClick?: () => void;
  onChevronClick?: () => void;
  disabled?: boolean;
  fullWidth?: boolean;
  isSubmitting?: boolean;
}

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 1px;
  width: fit-content;
`;

const Half = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  appearance: none;
  -webkit-appearance: none;
  font-family: "pf_highway_sans_pro_lightRg";
  background-color: ${(p) => (p.disabled ? "#E9E8EC" : colors.primaryButton)};
  color: ${(p) => (p.disabled ? "#9897A9" : colors.buttonText)};
  cursor: ${(p) => (p.disabled ? "not-allowed" : "pointer")};
  transition: background-color 0.3s ease;

  @media (hover: hover) {
    &:hover:not(:disabled) {
      background-color: ${colors.buttonHovered};
      color: ${colors.buttonTextHovered};
    }
  }

  &:active:not(:disabled) {
    background-color: ${colors.buttonPressed};
  }

  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    outline: 1px solid ${colors.primaryButton};
    outline-offset: 1px;
  }

  &:disabled {
    background-color: #e9e8ec;
    color: #a8abaf;
    cursor: not-allowed;
    pointer-events: none;
    transition: none;
  }
`;

const MainHalf = styled(Half)`
  padding: 16px 20px 16px 24px;
  border-radius: 24px 0 0 24px;
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  white-space: nowrap;
  height: 40px;
`;

const ChevronHalf = styled(Half)`
  padding: 12px 12px 12px 10px;
  border-radius: 0 24px 24px 0;
  height: 40px;
`;

const SplitButton: React.FC<SplitButtonProps> = ({
  text,
  onMainClick,
  onChevronClick,
  disabled = false,
  isSubmitting = false,
}) => (
  <Wrapper>
    <MainHalf type="button" onClick={onMainClick} disabled={disabled}>
      {text}
    </MainHalf>
    <ChevronHalf type="button" onClick={onChevronClick} disabled={disabled}>
      {isSubmitting ? (
        <Loading />
      ) : (
        <ArrowDown color={disabled ? "#9897A9" : "currentColor"} />
      )}
    </ChevronHalf>
  </Wrapper>
);

export default SplitButton;
